var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIconOutlined = function SvgWarningIconOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16h-2v2h2zm0-6h-2v5h2z"
  })));
};
export default SvgWarningIconOutlined;